import { defineMessages } from 'react-intl'

const messages = {
  closeButtonAriaLabel: {
    id: 'app.components.modal.close-button-aria-label',
    defaultMessage: 'Close modal',
  },
}

export default defineMessages(messages)
